import {apiAction} from './helper';

export const GET_CONFIG_ROLES = apiAction('GET_CONFIG_ROLES');
export const GET_CLIENT_ROLES = apiAction('GET_CLIENT_ROLES');
